'use client'

import { createContext, useContext } from 'react'

export type CdnContextValue = {
  mediaServerUrl: string
  productImageCdnUrl: string
  visualAssetUrl: string
}

export const CdnContext = createContext<CdnContextValue | undefined>(undefined)

export const useCdnContext = (): CdnContextValue => {
  const value = useContext(CdnContext)

  if (!value) {
    throw new Error('CdnProvider is not provided')
  }

  return value
}
